import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

interface AgeRestrictionVideoDetails {
    videoWidth: number;
    videoHeight: number;
}

export const getVideoSize = (stream: MovieStreamFragment | null): AgeRestrictionVideoDetails => {
    if (stream) {
        const videoMeta = stream?.streamMeta?.videoMetas[0];
        return {
            videoHeight: videoMeta?.height ?? 0,
            videoWidth: videoMeta?.width ?? 0,
        };
    }
    return {
        videoHeight: 0,
        videoWidth: 0,
    };
};
